module.exports = __webpack_public_path__ + "static/media/94.4bf6e00b.png";